import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { CallIcon } from "@/components/CallIcon";
import { dates } from "@/lib/dates";

import { VoiceAIOutreachSlim, VoiceAIOutreachStatus } from "@/types";

export const VoiceAIOutreachInformation = ({
  voiceAIOutreachSlim,
}: {
  voiceAIOutreachSlim: VoiceAIOutreachSlim;
}) => {
  return (
    <Row className="items-center gap-2">
      <CallIcon
        circleClassName="h-6 w-6"
        className="h-3 w-3"
        isAi
        isVoicemail={
          voiceAIOutreachSlim.status === VoiceAIOutreachStatus.VOICEMAIL
        }
        status={voiceAIOutreachSlim.status}
      />
      <Text>
        {dates.formatIsoDateTimeForUser(
          voiceAIOutreachSlim.scheduledDateTime,
        )}
      </Text>
      {voiceAIOutreachSlim.adminMetadata?.completed && (
        <div className="rounded-full border border-green-200 bg-green-50 px-1.5 py-0.5">
          <p className="text-xs font-medium text-green-700">Enriched</p>
        </div>
      )}
    </Row>
  );
};
